<div id="contentframe" *ngIf="iframelink && iframelink.length">
    <iframe #iframe id="contentiframe" name="contentiframe" frameborder="0" width="100%" height="100%"
        (load)="iframeLoad($event)" [src]="iframelinkSafe">
        <p>Your browser does not support iframes.</p>
    </iframe>
</div>